import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { Footer } from "../components/Footer.js";
import { Account_head } from "./../components/account_head.js";
import { get_order_list, reorder_api } from "../service/api.js";
import Head_CateHead from '../components/Head_CateHead.js';
import ErrorSnackbar from '../components/ErrorSnackbar.js';

// Completed Orders: orders that ARE Dispatched OR Complete
const COMPLETED_STATUSES = ["DISPATCHED", "COMPLETE"];

export const Acc_order_list = () => {
    const navigate = useNavigate();
    const [data, setdata] = useState([]);
    const [loading, setLoading] = useState(true);
    const [reordering, setReordering] = useState(null); // tracks which OrderID is in-flight
    const [ExceptionError, setExceptionError] = useState([]);

    function handleExceptionError(msg) {
        setExceptionError(prev => [...prev, { id: Date.now(), message: msg }]);
    }
    function clearErrors(id) {
        setExceptionError(prev => prev.filter(e => e.id !== id));
    }

    const data_get = async () => {
        try {
            const res = await get_order_list();
            const all = res?.data?.Data ?? [];
            // Filter to only completed/dispatched orders
            const completed = all.filter(
                (item) => COMPLETED_STATUSES.includes(item.Status)
            );
            setdata(completed);
        } catch (error) {
            console.error("Error fetching completed orders:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (localStorage.getItem('token')) {
            data_get();
        } else {
            navigate("/signin");
        }
    }, []);

    const viewOrder = (id) => {
        navigate(`/order_detail/${id}`);
    };

    // Re Order: store OrderID, call API, redirect to checkout on success
    const handleReorder = async (orderId) => {
        setReordering(orderId);
        try {
            // 1. Store the order ID so checkout can read it for the PO# field
            localStorage.setItem('reorderOrderId', String(orderId));

            // 2. Call the reorder API — this copies order items into the user's cart
            const res = await reorder_api(orderId);

            if (res?.status === 200) {
                // 3. Success: navigate to checkout
                navigate('/checkout');
            } else {
                // 4. Failure: remove the stored ID, show error, do NOT navigate
                localStorage.removeItem('reorderOrderId');
                const msg =
                    res?.response?.data?.ErrorMessage ||
                    res?.data?.ErrorMessage ||
                    'Re Order failed. Please try again.';
                handleExceptionError(msg);
            }
        } catch (err) {
            localStorage.removeItem('reorderOrderId');
            handleExceptionError('Re Order failed. Please try again.');
        } finally {
            setReordering(null);
        }
    };

    const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return '—';
        const options = {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };
        return new Intl.DateTimeFormat('en-GB', options).format(new Date(dateTimeString));
    };

    // Format dispatch/shipping date — date only (no time needed)
    const formatDate = (dateString) => {
        if (!dateString) return '—';
        try {
            const options = { year: '2-digit', month: '2-digit', day: '2-digit' };
            return new Intl.DateTimeFormat('en-GB', options).format(new Date(dateString));
        } catch {
            return '—';
        }
    };

    return (
        <div className='order_list_main'>
            <ErrorSnackbar errorMessages={ExceptionError} onClearErrors={clearErrors} />
            <Head_CateHead />
            <Account_head title_="Completed Orders" />
            {loading ? (
                <div style={{ textAlign: 'center', marginTop: '40px' }}>
                    <p style={{ fontSize: '18px' }}>Loading...</p>
                </div>
            ) : data.length > 0 ? (
                <div className="sign_in_wrapper container account w-75">
                    <table width="100%" className='order_list_table'>
                        <thead>
                            <tr>
                                <th>Order Id</th>
                                <th>Order Placed On</th>
                                <th>Status</th>
                                <th>Dispatch Date</th>
                                <th>Tracking</th>
                                <th>Total</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={item.OrderID ?? index}>
                                    <td
                                        style={{ cursor: 'pointer', color: '#01AEF0' }}
                                        onClick={() => viewOrder(item.OrderID)}
                                    >
                                        #{item.OrderID}
                                    </td>
                                    <td>{formatDateTime(item.CreatedOn)}</td>
                                    <td>{item.Status || '—'}</td>
                                    <td>{formatDate(item.ShippingDate)}</td>
                                    <td>
                                        {item.ShippingTrackLink ? (
                                            <a
                                                href={item.ShippingTrackLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: '#01AEF0' }}
                                            >
                                                Track Here
                                            </a>
                                        ) : (
                                            '—'
                                        )}
                                    </td>
                                    <td>${item.Totalprice}</td>
                                    <td>
                                        <button
                                            onClick={() => handleReorder(item.OrderID)}
                                            disabled={reordering === item.OrderID}
                                            style={{ backgroundColor: '#01AEF0' }}
                                        >
                                            {reordering === item.OrderID ? 'Please wait…' : 'Re Order'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div style={{ textAlign: 'center', marginTop: '-20px' }}>
                    <p style={{ fontSize: '30px' }}>No completed orders yet.</p>
                    <br />
                    <Link to="/shop"><button className="spe_ex_button">Shop</button></Link>
                    <br />
                    <br />
                    <br />
                </div>
            )}
            <Footer />
        </div>
    );
};
